import { Pipe, PipeTransform } from "@angular/core";
import { PAYMENT_CURRENCY_SYMBOL } from "@dtm-frontend/shared/utils";
import { LocalizeNumberPipe } from "../modules/i18n/pipes/localize-number.pipe";

@Pipe({
    name: "formatPaymentCurrency",
})
export class FormatPaymentCurrencyPipe implements PipeTransform {
    private readonly localizeNumberPipe = new LocalizeNumberPipe();

    public transform(value?: string | number | null): string {
        const valueFormatted = this.localizeNumberPipe.transform(value, { minimumFractionDigits: 2 });

        if (PAYMENT_CURRENCY_SYMBOL === "PLN") {
            return this.formatPlnValue(valueFormatted);
        }

        return this.formatDefaultValue(valueFormatted);
    }

    private formatPlnValue(value: string) {
        // eslint-disable-next-line no-irregular-whitespace
        return `${value} ${PAYMENT_CURRENCY_SYMBOL}`;
    }

    private formatDefaultValue(value: string) {
        // eslint-disable-next-line no-irregular-whitespace
        return `${value} ${PAYMENT_CURRENCY_SYMBOL}`;
    }
}
